import React from "react";
import { LinearProgress, Stack, useTheme } from "@mui/material";

const NavbarLoader = () => {
  const theme = useTheme();
  return (
    <Stack sx={{ width: "100vw" }}>
      <LinearProgress
        sx={{
          backgroundColor: theme.palette.grey[200],
          "& .MuiLinearProgress-bar": {
            backgroundColor: theme.palette.primary.main,
          },
        }}
      />
    </Stack>
  );
};

export { NavbarLoader };
